/**
 * ver 0.1
 * author jack
 */
import React from 'react'

class LoginMobileLayer extends React.Component {
    goLogin() {
        window.location.href = process.env.REACT_APP_SSO_URL
        this.props.onClose()
    }

    render() {
        return (
            <div className="layerPop">
                <div className="layerCon">
                    <div className="Popcont">
                        <strong><font className="clrpont1">로그인이</font> 필요한 서비스 입니다.</strong>
                    </div>
                    <div className="popBtnWrap">
                        <button type="button" className="popnor" onClick={() => this.props.onClose()}>닫기</button>
                        <a href={process.env.REACT_APP_SSO_URL} className="popbg1" target="_self" rel="noopener noreferrer">로그인 하러가기</a>
                    </div>
                    <button type="button" className="btn_layer_clse" onClick={() => this.props.onClose()}><i className="icon-close"></i><span className="ir">닫기</span></button>
                </div>
            </div>
        )
    }
}
export default LoginMobileLayer



// WEBPACK FOOTER //
// ./src/common/container/layer/loginMobileLayer.js